import config from "@/config";
import http from "@/utils/request";
export default {
	toDayOrders: {
		url: `${config.API_URL}/orders/of/search/self/page`,
		name: "今日下单量",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	FBACreate: {
		url: `${config.API_URL}/orders/cremainorder`,
		name: "FBA下单",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
};
